import React, { FunctionComponent } from "react";
import axios from "axios";
import FlexColumn from "designSystem/components/flex/FlexColumn";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import RequestErrorPlaceholder, { RequestErrorPlaceholderProps } from "designSystem/components/placeholder/RequestErrorPlaceholder";
import { FallbackProps } from "react-error-boundary";

/**
 * Error fallback widget to use with {@link https://github.com/bvaughn/react-error-boundary|react-error-boundary}.
 *
 * It tries to display some meaningful message if Fashion Inspiration API returned with some error.
 *
 * If the error is not from Fashion Inspiration API, it displays the generic error message
 */
export const ErrorFallback: FunctionComponent<FallbackProps> = ({ error, resetErrorBoundary }) => {
	if (axios.isAxiosError(error) && error.response) {
		const { response } = error;
		switch (response.status) {
			case 422:
				return (
					<ErrorPanel
						onRetry={resetErrorBoundary}
						subtitleRes="ValidationError"
						titleRes="ValidationError_Description"
					/>
				);

			default:
				return (<ErrorPanel onRetry={resetErrorBoundary} />);
		}
	} else {
		return (<ErrorPanel onRetry={resetErrorBoundary} />);
	}
};

const ErrorPanel: FunctionComponent<RequestErrorPlaceholderProps> = (props) => {
	return (
		<FlexColumn>
			<FlexRowCenter
				flexGrow={1}
				justifyContent="center"
				px={3}
			>
				<RequestErrorPlaceholder {...props} />
			</FlexRowCenter>
		</FlexColumn>
	);
};
